import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { QRCodeCanvas } from 'qrcode.react';

const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #1e4d92 0%, #2d8fe5 100%);
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Card = styled.div`
  width: 90%;
  max-width: 450px;
  margin: 1rem auto;
  padding: 2rem;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.1);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 768px) {
    padding: 2.5rem;
    width: 85%;
  }
`;

const Title = styled.h1`
  font-size: 1.8rem;
  color: #1e4d92;
  text-align: center;
  margin-bottom: 1.5rem;
  line-height: 1.3;
  max-width: 300px;

  @media (min-width: 768px) {
    font-size: 2.2rem;
    margin-bottom: 2rem;
    max-width: 350px;
  }
`;

const QRContainer = styled.div`
  margin: 1.5rem 0;
  padding: 1rem;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ControlsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
  margin: 0.5rem 0;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: center;
    gap: 1rem;
  }
`;

const Select = styled.select`
  width: 120px;
  padding: 0.7rem;
  border-radius: 8px;
  border: 2px solid #1e4d92;
  font-size: 1rem;
  cursor: pointer;
  text-align: center;
`;

const Button = styled.button`
  width: 160px;
  padding: 0.7rem;
  font-size: 1rem;
  background: #1e4d92;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #163a6f;
    transform: translateY(-2px);
  }
`;

const MessageContainer = styled.div`
  width: 100%;
  margin-top: 1.5rem;
  padding: 1.5rem 1rem;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: center;
`;

const Message = styled.p`
  font-size: 0.9rem;
  color: #333;
  text-align: center;
  line-height: 1.6;
  margin: 0;
  word-wrap: break-word;
  max-width: 100%;

  @media (min-width: 768px) {
    font-size: 1rem;
  }
`;

const StyledLink = styled.a`
  color: #1e4d92;
  text-decoration: none;
  font-weight: bold;
  display: inline-block;
  padding: 0 4px;
  
  &:hover {
    text-decoration: underline;
  }
`;

const PurchaseButton = styled.a`
  display: inline-block;
  width: 100%;
  max-width: 300px;
  padding: 1rem;
  margin-top: 2rem;
  font-size: 1rem;
  background: #1e4d92;
  color: white;
  text-decoration: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #163a6f;
    transform: translateY(-2px);
  }
`;

const QROverlay = styled.div`
  position: relative;
  
  &::after {
    content: "DEMONSTRAÇÃO";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-45deg);
    font-size: 24px;
    color: rgba(30, 77, 146, 0.5);
    font-weight: bold;
    pointer-events: none;
    white-space: nowrap;
    text-shadow: 2px 2px 4px rgba(255,255,255,0.8);
  }
`;

const SuccessPage = () => {
  const [format, setFormat] = useState('png');
  const location = useLocation();
  const { formData } = location.state || {};
  
  const qrValue = `${window.location.origin}/profile/${formData?.id}`;

  const handleDownload = () => {
    const qrCanvas = document.querySelector('canvas');
    const tempCanvas = document.createElement('canvas');
    const ctx = tempCanvas.getContext('2d');
    
    // Set canvas size
    tempCanvas.width = qrCanvas.width;
    tempCanvas.height = qrCanvas.height;
    
    // Draw QR Code
    ctx.drawImage(qrCanvas, 0, 0);
    
    // Add watermark
    ctx.font = 'bold 24px Arial';
    ctx.fillStyle = 'rgba(30, 77, 146, 0.5)';
    ctx.save();
    ctx.translate(tempCanvas.width/2, tempCanvas.height/2);
    ctx.rotate(-45 * Math.PI / 180);
    ctx.textAlign = 'center';
    ctx.fillText('DEMONSTRAÇÃO', 0, 0);
    ctx.restore();
    
    // Create download link
    const url = tempCanvas.toDataURL(`image/${format}`);
    const link = document.createElement('a');
    link.download = `qr-code.${format}`;
    link.href = url;
    link.click();
  };
  
  // No componente, após ControlsContainer:
  return (
    <Container>
      <Card>
        <Title>QR Code<br />Gerado com Sucesso!</Title>
        <QRContainer>
          <QROverlay>
            <QRCodeCanvas value={qrValue} size={256} level="H" />
          </QROverlay>
        </QRContainer>
        <ControlsContainer>
          <Select value={format} onChange={(e) => setFormat(e.target.value)}>
            <option value="png">PNG</option>
            <option value="svg">SVG</option>
            <option value="pdf">PDF</option>
          </Select>
          <Button onClick={handleDownload}>Baixar QR Code</Button>
        </ControlsContainer>
        <PurchaseButton 
          href="http://www.qrsalve.com.br"
          target="_blank"
          rel="noopener noreferrer"
        >
          Clique aqui para adquirir seu QrSalve
        </PurchaseButton>
      </Card>
    </Container>
  );
};

export default SuccessPage;